$(document).ready(function () {

  // Click on nav link: close menu + remove overflow
  $(".header-wrapper nav ul li a").click(function () {
    $(".menu-drawer-container").removeClass("menu-opening");
    $("html").removeClass("overflow-hidden");
  });

  // Click on menu icon: toggle both together
  $(".menu-drawer-container .header__icon span").click(function () {
    const $menuDrawer = $(".menu-drawer-container");

    if ($menuDrawer.hasClass("menu-opening")) {
      // If already open → close it
      $menuDrawer.removeClass("menu-opening");
      $("html").removeClass("overflow-hidden");
    } else {
      // If closed → open it
      $menuDrawer.addClass("menu-opening");
      $("html").addClass("overflow-hidden");
    }
  });

  // Fancy Box Start
Fancybox.bind("[data-fancybox]", {});
// Fancy Box End

  AOS.init({
    // ... your other initialisation options here ...
    once: true,
  });


});


$(window).on("load", function () {
  $(".review-carousel").carouselTicker({
    speed: 3,
  });
});


(function () {
    const header = document.querySelector('.header-wrapper');

    if (!header) return;

    function updateHeader() {
      if (window.scrollY > 10) {
        header.classList.add('is-sticky-scroll');
      } else {
        header.classList.remove('is-sticky-scroll');
      }
    }

    // Run on load (fixes hard refresh issue)
    window.addEventListener('load', updateHeader);

    // Run on scroll
    window.addEventListener('scroll', updateHeader);

    // Run on page navigation (Shopify cache)
    document.addEventListener('shopify:section:load', updateHeader);
  })();

